export default "__VITE_ASSET__DDPR8ceh__"